import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import AddressMap from "./AddressMap";
import normalize from "../utils/NormalizeSelect";

const BillingAddress = ({
  data,
  processData,
  error,
  setData,
  setError,
  column = 1,
}) => {
  const [areas, setAreas] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [streets, setStreets] = useState([]);
  const token = localStorage.getItem("token");

  const fetchAreaList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/areas`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setAreas(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchBlockList = () => {
    const areaName = encodeURIComponent(data?.billingArea?.value);
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/blocks/${areaName}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setBlocks(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchStreetList = () => {
    const areaName = encodeURIComponent(data?.billingArea?.value);
    const blockName = encodeURIComponent(data?.billingBlock?.value);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}location/streets/${areaName}/${blockName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setStreets(res.data.data);
        }
      })
      .catch(console.error);
  };

  const coordsFrom = (locationObj) => {
    const lat = parseFloat(locationObj?.latitude);
    const lng = parseFloat(locationObj?.longitude);
    return !isNaN(lat) && !isNaN(lng) ? { billingLatitude: lat, billingLongitude: lng } : {};
  };

  useEffect(() => {
    fetchAreaList();
  }, []);
  useEffect(() => {
    setBlocks([]);
    setStreets([]);
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        billingBlock: null,
        billingStreet: null,
        ...coordsFrom(data?.billingArea),
        legalArea: data?.billingArea,
      });
      setError({
        ...error,
        billingBlock: null,
        billingStreet: null,
        legalArea: null,
      });
    } else {
      setData({
        ...data,
        billingBlock: null,
        billingStreet: null,
        ...coordsFrom(data?.billingArea),
      });
      setError({
        ...error,
        billingBlock: null,
        billingStreet: null,
      });
    }
    fetchBlockList();
  }, [data?.billingArea]);
  useEffect(() => {
    setStreets([]);
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        billingStreet: null,
        ...coordsFrom(data?.billingBlock),
        legalBlock: data?.billingBlock,
      });
      setError({
        ...error,
        billingStreet: null,
        legalBlock: null,
      });
    } else {
      setData({
        ...data,
        billingStreet: null,
        ...coordsFrom(data?.billingBlock),
      });
      setError({
        ...error,
        billingStreet: null,
      });
    }
    fetchStreetList();
  }, [data?.billingBlock]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        ...coordsFrom(data?.billingStreet),
        legalStreet: data?.billingStreet,
      });
      setError({
        ...error,
        legalStreet: null,
      });
    } else {
      setData({
        ...data,
        ...coordsFrom(data?.billingStreet),
      });
    }
  }, [data?.billingStreet]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalBuildingNoOrName: data?.billingBuildingNoOrName,
      });
      setError({
        ...error,
        legalBuildingNoOrName: null,
      });
    }
  }, [data?.billingBuildingNoOrName]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalJadda: data?.billingJadda,
      });
      setError({
        ...error,
        legalJadda: null,
      });
    }
  }, [data?.billingJadda]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalApartmentOrOffice: data?.billingApartmentOrOffice,
      });
      setError({
        ...error,
        legalApartmentOrOffice: null,
      });
    }
  }, [data?.billingApartmentOrOffice]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalFloor: data?.billingFloor,
      });
      setError({
        ...error,
        legalFloor: null,
      });
    }
  }, [data?.billingFloor]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalLatitude: isNaN(parseFloat(data?.billingLatitude))
          ? ""
          : parseFloat(data?.billingLatitude),
        legalLongitude: isNaN(parseFloat(data?.billingLongitude))
          ? ""
          : parseFloat(data?.billingLongitude),
      });
      setError({
        ...error,
        legalLatitude: null,
        legalLongitude: null,
      });
    }
  }, [data?.billingLatitude, data?.billingLongitude]);

  return (
    <>
      <div className="card-header">
        <div className="card-title">Billing Address</div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className={column === 2 ? "col-md-6" : "col-md-12"}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label required">Area</label>

                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.billingArea
                      ? {
                        label: data?.billingArea?.value,
                        value: data?.billingArea,
                      }
                      : null
                  }
                  onChange={(e) => {
                    processData("select", e, "billingArea");
                  }}
                  options={areas?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  placeholder="Select an option"
                />
                {error.billingArea !== undefined && error.billingArea !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingArea}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Block</label>
                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.billingBlock
                      ? {
                        label: data?.billingBlock?.value,
                        value: data?.billingBlock,
                      }
                      : null
                  }
                  onChange={(e) => {
                    setStreets([]);
                    processData("select", e, "billingBlock");
                  }}
                  options={blocks?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  placeholder="Select an option"
                />
                {error.billingBlock !== undefined &&
                  error.billingBlock !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingBlock}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label required">Street</label>
                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.billingStreet
                      ? {
                        label: data?.billingStreet?.value,
                        value: data?.billingStreet,
                      }
                      : null
                  }
                  onChange={(e) => {
                    processData("select", e, "billingStreet");
                  }}
                  options={streets?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  placeholder="Select an option"
                />
                {error.billingStreet !== undefined &&
                  error.billingStreet !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingStreet}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">
                  Building Number or Name
                </label>
                <input
                  id="billing_building_no_or_name"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Building Number or Name"
                  data-error="* Please Enter Buiding No."
                  value={data?.billingBuildingNoOrName ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingBuildingNoOrName");
                  }}
                />
                {error.billingBuildingNoOrName !== undefined &&
                  error.billingBuildingNoOrName !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingBuildingNoOrName}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Jadda</label>
                <input
                  id="billing_jadda"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Jadda"
                  data-error="* Please Enter Jadda"
                  value={data?.billingJadda ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingJadda");
                  }}
                />
                {error.billingJadda !== undefined &&
                  error.billingJadda !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingJadda}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Apartment/Office</label>
                <input
                  id="billing_apartment_or_office"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Apartment or Office Details"
                  data-error="* Apartment or Office Details"
                  value={data?.billingApartmentOrOffice ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingApartmentOrOffice");
                  }}
                />
                {error.billingApartmentOrOffice !== undefined &&
                  error.billingApartmentOrOffice !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingApartmentOrOffice}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Floor</label>
                <input
                  id="billing_floor"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Floor"
                  data-error="* Floor Details"
                  value={data?.billingFloor ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingFloor");
                  }}
                />
                {error.billingFloor !== undefined &&
                  error.billingFloor !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingFloor}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Latitude</label>
                <input
                  id="billing_latitude"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Latitude"
                  data-error="* Latitude Details"
                  value={data?.billingLatitude ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingLatitude");
                  }}
                />
                {error.billingLatitude !== undefined &&
                  error.billingLatitude !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingLatitude}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Longitude</label>
                <input
                  id="billing_longitude"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Longitude"
                  data-error="* Longitude Details"
                  value={data?.billingLongitude ?? ""}
                  onChange={(e) => {
                    processData("text", e, "billingLongitude");
                  }}
                />
                {error.billingLongitude !== undefined &&
                  error.billingLongitude !== "" ? (
                  <small className="text-danger mt-2">
                    {error.billingLongitude}
                  </small>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className={column === 2 ? "col-md-6 pt-5" : "col-md-12 pt-5"}>
            <div
              className="mt-5"
              style={{ height: "350px", width: "100%" }}
              id="billingAddressMap"
            >
              <AddressMap
                data={data}
                setData={setData}
                setErrors={setError}
                type="billing"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingAddress;
